import type { ColDef, ColumnMenuTab } from 'ag-grid-community';

const menuTabs: ColumnMenuTab[] = [
  'columnsMenuTab',
  'filterMenuTab',
  'generalMenuTab'
];

type CombinationRow = {
  word: string;
  length: number;
};

type CombinationColumn = ColDef<CombinationRow> & {
  searchable?: boolean;
  title?: string;
  type?: string;
};

export const combinationColumnConfig: CombinationColumn[] = [
  {
    field: 'word',
    type: 'string',
    title: 'عنوان',
    flex: 1,
    width: 250,
    searchable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    menuTabs
  },
  {
    field: 'length',
    type: 'number',
    title: 'طول',
    width: 90,
    searchable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    menuTabs
  }
];
